import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import darkBarcode from '../../assets/images/darkbarcode.png';
import scannerIcon from '../../assets/images/Bar_code_scan.png';
import { ScanOrEnterBarcodeForm } from '../../components';
import { useMessageContextManager } from '../../components/MessageOverlay/MessageOverlay';
import {
	ADDITIONAL_COLUMNS_FOR_CHASSIS_LINE,
	CHASIS_LINE_IDS,
	COLUMNS_TO_HIDE_FOR_CHASSIS_LINE,
	DARK_MODE,
	DEFAULT_COLUMNS,
	PART_VALIDATION_ERROR,
} from '../../constants';
import { useAjaxCallbackWithIntervals } from '../../hooks';
import {
	fetchProcessedAgsns,
	partTakeIn,
} from '../../redux/actionCreators/station';
import BasicTable from '../Table/Table';
import { receivePart } from '../../redux/actionCreators/receivePart';

const ADDITIONAL_COLUMNS = [
	{ title: 'Serial No. / VIN', field: 'serialNumber', width: 300 },
	...DEFAULT_COLUMNS.map((col) => {
		return { ...col, enableFilter: false, enableSearch: false };
	}),
];

const ADDITIONAL_CHASSIS_LINE_COLUMNS = [
	...ADDITIONAL_COLUMNS_FOR_CHASSIS_LINE.map((col) => {
		return { ...col, enableFilter: false, enableSearch: false };
	}),
];

const classNames = {
	paper: {
		height: '75vh',
		display: 'flex',
		flexDirection: 'column',
	},
	tableContainer: {
		height: '100%',
	},
	tableContentContainer: {
		flex: 1,
		backgroundColor: 'background.default',
		borderBottomLeftRadius: '5px',
		borderBottomRightRadius: '5px',
		padding: '20px',
	},
};

const mapStateToProps = (state) => {
	return {
		themeMode: state.theme.themeMode,
		user: state.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	fetchProcessedAgsns: (successCallback, errorCallback) =>
		dispatch(fetchProcessedAgsns(successCallback, errorCallback)),
	partTakeIn: (sequenceNumber, successCallback, errorCallback) =>
		dispatch(partTakeIn(sequenceNumber, null, successCallback, errorCallback)),
	receivePart: (serialNumber, successCallback, errorCallback) =>
		dispatch(receivePart(serialNumber, successCallback, errorCallback)),
});

const UpdateUnprocessedParts = ({
	partTakeIn,
	selectedRows,
	themeMode,
	receivePart,
	redirectToNextScreen,
}) => {
	const { showMessageOverlay } = useMessageContextManager();
	const partNumberInputRef = useRef(null);
	const onPartNumberSubmit = (scannedValue, resetBarcodeValue) => {
		const updatedScannedValue = scannedValue.substring(0, 17);

		if (selectedRows[0]?.serialNumber == updatedScannedValue) {
			partTakeIn(
				selectedRows[0]?.sequenceNumber,
				() => {
					receivePart(
						updatedScannedValue,
						() => {
							resetBarcodeValue();
							redirectToNextScreen();
						},
						(error) => {
							resetBarcodeValue();
							showMessageOverlay({
								contextText:
									PART_VALIDATION_ERROR.ERROR_CONTEXT_TEXT + 'Part Validation',
								info: error?.response?.data?.message,
								error: true,
							});
							// logError(`Receive Part and Booking flow ${error}`);
						},
					);
				},
				(error) => {
					resetBarcodeValue();
					showMessageOverlay({
						contextText: error?.response?.data?.message,
						info: ' ',
						error: true,
					});
					// logError(`Part Takein ${error}`);
				},
			);
		} else {
			resetBarcodeValue();
			showMessageOverlay({
				contextText: 'Vin is Invalid.',
				info: ' ',
				error: true,
			});
		}
	};

	const renderInputFields = () => {
		return (
			<Grid
				container
				direction="row"
				justifyContent="space-between"
				paddingTop={6}
				paddingBottom={3}
				paddingX={3}
				sx={classNames.tableContentContainer}
			>
				<Grid item />
				<Grid
					item
					container
					justifyContent="flex-end"
					columnSpacing={2}
					xs={5}
					sx={{ opacity: selectedRows.length == 1 ? '100%' : '50%' }}
				>
					<Grid item display="flex" alignItems="center">
						<Typography variant="h3" sx={{ color: '#27C8F7' }}>
							SCAN SERIAL NO. / VIN
						</Typography>

						<Box
							item
							sx={{
								height: { xs: 35, md: 40, lg: 60 },
								width: { xs: 75, md: 85, lg: 130 },
							}}
						>
							<img
								src={themeMode === DARK_MODE ? darkBarcode : scannerIcon}
								alt=""
								style={{
									height: '100%',
									width: '100%',
									objectFit: 'cover',
								}}
							/>
						</Box>
					</Grid>
					<Grid item xs={12} sx={{ width: { sm: '75%', md: '60%' } }} pt={1}>
						<ScanOrEnterBarcodeForm
							enableAutoEnter
							inputRef={partNumberInputRef}
							inputProps={{
								disabled: selectedRows.length !== 1,
							}}
							isAlphaNumericValidation={false}
							onSubmit={onPartNumberSubmit}
						/>
					</Grid>
				</Grid>
			</Grid>
		);
	};

	useEffect(() => {
		if (partNumberInputRef.current) partNumberInputRef.current.focus();
	}, [selectedRows]);

	return <>{renderInputFields()}</>;
};

export const UnProcessedParts = ({
	fetchProcessedAgsns,
	partTakeIn,
	handleCountChange,
	themeMode,
	receivePart,
	getPartValidationDetailsForSerialNumber,
	redirectToNextScreen,
	user
}) => {
	const [rowData, setRowsData] = useState([]);
	const [hasActiveEdits, setHasActiveEdits] = useState(false);

	const getData = async () => {
		fetchProcessedAgsns(
			(data) => {
				setRowsData(
					data.map((row) => ({
						...row,
						id: row.sequenceNumber,
						readyForDropSequenceNumber: row.metaData.readyForDropSequenceNumber,
						vcDescription: row.metaData.vcDescription,
						vcSequenceNumber: row.metaData.vcSequenceNumber,
						vcPartNumber: row.metaData.vcPartNumber,
						shiftLabel: row.metaData.shiftLabel,
						vcNumber: row.metaData.vcNumber,
						majorModel:row.metaData.majormodel,
							country:row.metaData.country,
					})),
				);
			},
			(error) => console.log(error),
		);
	};

		const ChasisLineColums = [...ADDITIONAL_COLUMNS, ...ADDITIONAL_CHASSIS_LINE_COLUMNS]

	const filteredOriginalDefaultColumns = useMemo(() => {
		if (CHASIS_LINE_IDS.includes(user?.lineId)) {
				return ChasisLineColums.filter((res) => {
						return !COLUMNS_TO_HIDE_FOR_CHASSIS_LINE.includes(res.field);
				});
		}
		return ADDITIONAL_COLUMNS; // Return the array directly
}, [ADDITIONAL_COLUMNS,ADDITIONAL_COLUMNS_FOR_CHASSIS_LINE, user?.lineId]);


	useAjaxCallbackWithIntervals(false, hasActiveEdits, getData);

	return (
		<BasicTable
			listId="unprocessed-vin"
			rows={rowData}
			columns={[...filteredOriginalDefaultColumns]}
			defaultColumns={[...filteredOriginalDefaultColumns]}
			subtitle="Unprocessed VINs"
			tableStyles={{
				tableContainer: classNames.tableContainer,
				paper: classNames.paper,
			}}
			showCheckBox
			setHasActiveEdits={setHasActiveEdits}
			setCount={handleCountChange}
			search={{
				fieldToSearch: 'serialNumber',
				placeholder: 'Search Serial No. / VIN',
			}}
		>
			{(selectedRows) => (
				<UpdateUnprocessedParts
					partTakeIn={partTakeIn}
					selectedRows={selectedRows}
					getData={getData}
					themeMode={themeMode}
					receivePart={receivePart}
					getPartValidationDetailsForSerialNumber={
						getPartValidationDetailsForSerialNumber
					}
					redirectToNextScreen={redirectToNextScreen}
				/>
			)}
		</BasicTable>
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(UnProcessedParts);
